import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom, map, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CmsService } from '../../_core/services/cms.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private cmsService: CmsService
  ) {}

  checkLockedFlag() {
    //to do: api request
    return firstValueFrom(
      this.cmsService.getLockedFlag().pipe(
        map((res) => res[0].data.lock.data.attributes.locked),
        tap((isLocked) => {
          if (isLocked) {
            this.router.navigate(['system-not-available']);
          }
        })
      )
    );
  }
}
